import { Component, input, model, ModelSignal } from "@angular/core";
import { InColumnPlacement } from "../../constants";
import { NgClass } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SelectSingleRowDirective } from "../../directives";

@Component({
  selector: "common-select-row-cbx-column",
  standalone: true,
  imports: [NgClass, FormsModule, SelectSingleRowDirective],
  templateUrl: "./select-row-cbx-column.component.html",
  styleUrl: "./select-row-cbx-column.component.scss",
})
export class SelectRowCbxColumnComponent {
  readonly placement = input<InColumnPlacement>("CENTER");
  readonly isRowSelected: ModelSignal<boolean> = model<boolean>(false);
}
